var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkGs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    masktype: "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    rx: 4,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3102 23.9992H0.689685C0.308827 23.9992 0 23.7164 0 23.3676V0.631585C0 0.282811 0.308827 0 0.689685 0H39.3102C39.6911 0 39.9999 0.282811 39.9999 0.631585V23.3676C39.9998 23.7164 39.691 23.9992 39.3102 23.9992Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 0.631585C39.9998 0.282811 39.691 0 39.3102 0H36.2246L23.4481 7.66567V0H16.5516V7.66567L3.77514 0H0.689685C0.308827 0 0 0.282811 0 0.631585V2.26499L10.9616 8.84177H0V15.1573H10.9616L0 21.7342V23.3676C0 23.7164 0.308827 23.9992 0.689685 23.9992H3.77522L16.5517 16.3335V23.9992H23.4483V16.3335L36.2248 23.9992H39.3103C39.6912 23.9992 40 23.7164 40 23.3676V21.7342L29.0384 15.1574H39.9998V8.84184H29.0382L39.9998 2.26499V0.631585Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 10.1066H22.0689V0.00161743H17.9309V10.1066H0V13.8959H17.9309V24.0008H22.0689V13.8959H39.9998V10.1066Z",
    fill: "#FF4B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9803 15.157L0.0195312 23.4559C0.0683592 23.7609 0.342968 23.9989 0.689607 23.9989H1.63953L16.5137 15.1571H13.9803V15.157Z",
    fill: "#FF4B55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0615 15.157H24.5281L39.3806 23.9858C39.7268 23.952 40 23.6932 40 23.3672V22.848L27.0615 15.157Z",
    fill: "#FF4B55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.32812L12.6389 8.84119H15.1724L0.401795 0.0609436C0.165859 0.161319 0 0.377022 0 0.63093V1.32812Z",
    fill: "#FF4B55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9817 8.84177L39.9759 0.522911C39.9178 0.228009 39.649 0 39.3102 0H38.3222L23.4482 8.84177H25.9817Z",
    fill: "#FF4B55"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "saturation"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3101 24H0.689685C0.308827 24 0 23.7172 0 23.3684V0.631607C0 0.282821 0.308827 0 0.689685 0H39.3102C39.6911 0 39.9999 0.282821 39.9999 0.631607V23.3684C39.9998 23.7173 39.691 24 39.3101 24Z",
    fill: "#505050"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkGs);
export default __webpack_public_path__ + "static/media/UK-gs.7b77e49414b1e2a59620233bb8a42554.svg";
export { ForwardRef as ReactComponent };